export { default as ProductsIndexTableHeader } from './ProductsIndexTableHeader';
